import * as z from "zod";

export const generateOTPSchema = (length: number) => {
    const schemaObject: Record<string, z.ZodString> = {};
    for (let i = 0; i < length; i++) {
        schemaObject[`otp_${i}`] = z.string({
            required_error: `โปรดระบุ`
        }).length(1);
    }
    return z.object(schemaObject);
};

export type OTPValidatorSchema = {
    [Key in `otp_${number}`]: string;
};
